// Mock data for Equi Pulse Research website

export const companyInfo = {
  name: "Equi Pulse",
  tagline: "Where Passion Meets Performance",
  sebiReg: "INH000024046",
  gstNo: "23BIGPS0520N1Z9",
  email: "care@equipulseresearch.com",
  phone: "+91-8982892301",
  whatsapp: "918982892301",
  experience: "12+",
  description: "SEBI-registered Research Analyst offering data-driven equity research, market insights, and risk-optimized investment strategies for Indian investors."
};

export const socialLinks = {
  facebook: "https://www.facebook.com/profile.php?id=61585181202845",
  instagram: "https://www.instagram.com/equipulse1",
  telegram: "https://t.me/equipulse",
  twitter: "https://x.com/equi_pulse",
  linkedin: "https://www.linkedin.com/in/equi-pulse-092280373/"
};

export const services = [
  {
    id: 1,
    name: "Equi Rider",
    tagline: "Designed for traders seeking concise, actionable trade ideas without market noise.",
    features: [
      "2–3 short-term swing trade ideas per week (Cash segment)",
      "Clear entry, stop-loss, and target levels",
      "Weekly market commentary (indices, sectors, key levels)",
      "Instant alerts via Telegram and WhatsApp",
      "Broadcast-only service (no personalized advisory)"
    ],
    whyChoose: [
      "Clean, no-hype trade ideas",
      "Strict risk–reward discipline",
      "Best suited for self-driven traders"
    ],
    price: "Contact for pricing",
    popular: false
  },
  {
    id: 2,
    name: "Equi Hunter",
    tagline: "Premium trade and portfolio guidance for active traders and serious investors.",
    features: [
      "2–3 day trade Cash Calls daily",
      "2–3 Index/Stock Derivatives Calls daily",
      "2–3 high-conviction swing trades per month",
      "Monthly portfolio review and allocation insights",
      "Daily market brief and weekly market report",
      "Delivery via Telegram and WhatsApp"
    ],
    whyChoose: [
      "High-frequency trade opportunities",
      "Strategic swing ideas for capital growth",
      "Portfolio support without full-time advisory fees"
    ],
    price: "Contact for pricing",
    popular: true
  },
  {
    id: 3,
    name: "Equi Master",
    tagline: "The most comprehensive plan for trade, investing, and portfolio-level strategy.",
    features: [
      "2–3 day trade Cash Calls daily",
      "2–3 Index/Stock Derivatives Calls daily",
      "2–3 Swing Trade Ideas monthly",
      "Optional commodity calls (Gold, Silver, Crude Oil)",
      "Monthly portfolio review with allocation strategy",
      "Long-term investment themes and earnings impact analysis",
      "Daily market brief and weekly market report",
      "1-on-1 consultation (once per quarter)",
      "Tax optimization strategies",
      "Priority access to webinars and events"
    ],
    whyChoose: [
      "Active traders in Cash and F&O segments",
      "Serious investors and HNI clients",
      "Clients seeking tax efficiency and portfolio-level support"
    ],
    price: "Contact for pricing",
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ravi S.",
    role: "Investor",
    content: "Equi Pulse's insights helped us navigate volatile markets with confidence and clarity.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1585734333426-b96221fbb2bb?auto=format&fit=crop&w=100&h=100"
  },
  {
    id: 2,
    name: "Priya M.",
    role: "Trader",
    content: "The research quality and timely recommendations have significantly improved my trading results.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=100&h=100"
  },
  {
    id: 3,
    name: "Amit K.",
    role: "HNI Client",
    content: "Professional, data-driven, and always ahead of the curve. Best decision for my portfolio.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=100&h=100"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Market Volatility in 2025",
    excerpt: "Key insights on navigating volatile markets with technical and fundamental analysis.",
    date: "2025-01-15",
    author: "Equi Pulse Research Team",
    category: "Market Analysis",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=800&h=400"
  },
  {
    id: 2,
    title: "Top Sectors to Watch This Quarter",
    excerpt: "Our research team identifies high-potential sectors based on macroeconomic trends.",
    date: "2025-01-10",
    author: "Equi Pulse Research Team",
    category: "Investment Strategy",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&h=400"
  },
  {
    id: 3,
    title: "Risk Management in F&O Trading",
    excerpt: "Essential strategies for managing risk in futures and options trading.",
    date: "2025-01-05",
    author: "Equi Pulse Research Team",
    category: "Trading Tips",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=800&h=400"
  }
];

export const aboutContent = {
  mission: "To provide data-driven, ethical, and client-centric research solutions that help traders, investors, and institutions navigate dynamic market conditions with confidence and discipline.",
  vision: "To be India's most trusted equity research platform, empowering investors with actionable insights and proven strategies.",
  approach: "Our research approach combines advanced technical analysis—price–volume behavior, trend dynamics, market structure, time cycles, and chart patterns—with rigorous fundamental evaluation of businesses, including financial health, intrinsic value, management quality, and macroeconomic factors.",
  expertise: "We are a SEBI Registered Research Analyst. Our team has over 12+ years of collective experience in equity research and market strategy. Our expertise spans technical and fundamental analysis, financial modeling, valuation, and risk–return optimization, enabling us to deliver reliable and actionable investment insights."
};

export const stockTickers = [
  "NSE:NIFTY",
  "BSE:SENSEX",
  "NSE:BANKNIFTY",
  "NSE:RELIANCE",
  "NSE:TCS",
  "NSE:INFY",
  "NSE:HDFCBANK",
  "NSE:ICICIBANK"
];

export const disclaimer = {
  title: "Important Disclaimer",
  content: `Equi Pulse is a SEBI-registered Research Analyst (Registration No. INH000024046).

INVESTMENTS IN THE SECURITIES MARKET ARE SUBJECT TO MARKET RISK. PLEASE READ ALL RELATED DOCUMENTS CAREFULLY BEFORE INVESTING.

Past performance is not indicative of future results. All investment decisions are at the sole discretion of the investor. Equi Pulse does not guarantee any returns or profits. The information provided is for educational and informational purposes only and should not be construed as investment advice.

Please consult with your financial advisor before making any investment decisions.`
};

// Mock function to simulate newsletter subscription
export const subscribeNewsletter = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Newsletter subscription:', email);
      resolve({ success: true, message: 'Successfully subscribed to newsletter!' });
    }, 1000);
  });
};

// Mock function to simulate contact form submission
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submission:', formData);
      resolve({ success: true, message: 'Thank you! We will get back to you soon.' });
    }, 1000);
  });
};

// Mock function to simulate consultation booking
export const bookConsultation = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Consultation booking:', formData);
      resolve({ success: true, message: 'Consultation request received! Our team will contact you shortly.' });
    }, 1000);
  });
};
